import styled from 'styled-components';
import CloseButton from './CloseButton';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';

interface ModalProps {
  children: React.ReactNode;
  isOnboarding: boolean;
  handleClose: () => void;
}

const SahelModal = ({ children, handleClose, isOnboarding }: ModalProps) => {
  const { locale } = useRouter();
  const drawerOpen = useSelector((state: any) => state.map.drawerOpen);

  return (
    <Container
      locale={locale}
      drawerOpen={drawerOpen}
      isOnboarding={isOnboarding}
    >
      <div className="close-btn">
        <CloseButton handleClick={handleClose} />
      </div>
      {children}
    </Container>
  );
};

const Container = styled.div<{
  locale: string | undefined;
  drawerOpen: boolean;
  isOnboarding: boolean;
}>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: ${props =>
    props.drawerOpen
      ? props.locale === 'en'
        ? 'translate(-85%, -50%)'
        : 'translate(-15%, -50%)'
      : 'translate(-50%, -50%)'};
  width: 452px;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  padding: 16px;
  background-color: ${props => (props.isOnboarding ? '#fff' : '#f9fafb')};
  border: 1px solid ${props => (props.isOnboarding ? '#fff' : '#f0f1f3')};
  border-radius: 16px;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.04),
    0px 8px 16px 0px rgba(0, 0, 0, 0.08);
  z-index: 99;

  .close-btn {
    position: absolute;
    top: 16px;
    inset-inline-end: 16px;
  }
`;

export default SahelModal;
